function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H100V100H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d1d1d1",
  d: "M66.223 87.507L58.9 73.4a7.524 7.524 0 0 0-6.807-4.021H14.5A7.476 7.476 0 0 0 7.7 73.4L.37 87.436a3.049 3.049 0 0 0-.37 1.34v18.977a6.219 6.219 0 0 0 6.363 6.067H60.3a6.221 6.221 0 0 0 6.363-6.067V88.847a3.623 3.623 0 0 0-.44-1.34zm-20.052-1.694a3.2 3.2 0 0 0-3.108 2.4c-.074.282-1.776 7.831-9.841 7.831-7.843 0-9.619-6.984-9.841-7.831a3.077 3.077 0 0 0-3.108-2.4H8.287l5.105-9.735a1.462 1.462 0 0 1 1.11-.705H52.09a1.175 1.175 0 0 1 1.11.705l5.031 9.735z",
  transform: "translate(16.667 -41.595)"
});

function SvgIconTrayWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrayWhite);
export default __webpack_public_path__ + "static/media/iconTrayWhite.14887b3e.svg";
export { ForwardRef as ReactComponent };